import { ABTEST_CONFIG, type ABTestName } from '$lib/constants/abtest';

export type VariantName<T extends ABTestName> = typeof ABTEST_CONFIG[T]['variants'][number];

export interface AbTestProperties {
	abtest_exp_id: number;
	abtest_exp_name: string;
	abtest_exp_var_name: string;
	abtest_exp_var: number;
}

let abTestProperties: AbTestProperties | undefined;

export const getAbTestProperties = (): AbTestProperties | undefined => abTestProperties;

export function setAbTestProperties<T extends ABTestName>(testName: T, variantName: VariantName<T>) {
	const abtestConfig = ABTEST_CONFIG[testName];

	abTestProperties = {
		abtest_exp_name: testName,
		abtest_exp_id: abtestConfig.testId,
		abtest_exp_var_name: variantName,
		abtest_exp_var: abtestConfig.variants.indexOf(variantName),
	};
}

export function resetAbTestProperties() {
	abTestProperties = undefined;
}
